(function () {
  class CustomerConsent extends Loan {
    constructor() {
      super()
      this.ofacAlertShown = false;
      this.pepAlertShown = false;
      this.lastValidatedDocument = null;
      this.lastValidatedName = null;
    };

    configure() {
      // BY IDs
      this.ui.companyID = "#loan_company_id";
      this.ui.personID = "#customer_consent_person_id";
      this.ui.loanCustomerNationality = "#customer_consent_customer_attributes_nationality";
      this.ui.loanCustomerNationalityCountry = "#customer_consent_customer_attributes_nationality_country";
      this.ui.loanCustomerBirthCountry = "#customer_consent_customer_attributes_birth_country";
      this.ui.customerId = "#customer_consent_customer_attributes_id";
      this.ui.customerIdNumber = "#customer_consent_customer_attributes_id_number";
      this.ui.customerIdNumberConfirmation = "#customer_consent_customer_attributes_id_number_confirmation";
      this.ui.customerFirstName = "#loan_customer_attributes_first_name";
      this.ui.customerSecondName = "#loan_customer_attributes_second_name";
      this.ui.customerFirstLastName = "#loan_customer_attributes_first_last_name";
      this.ui.customerSecondLastName = "#customer_consent_customer_attributes_second_last_name";
      this.ui.customerMarriedSurname = "#customer_consent_customer_attributes_married_surname";
      this.ui.customerBirthDate = "#customer_consent_customer_attributes_birth_date";
      this.ui.customerGender = "#customer_consent_customer_attributes_gender";
      this.ui.customerCellphone = "#customer_consent_cellphone_number";
      this.ui.customerEmail = "#customer_consent_email";
      this.ui.customerPhontoID = "#customer_consent_customer_attributes_id_photo, ";
      this.ui.customerPhotoFront = "#customer_consent_id_photo_front, #customer_consent_temporal_image_attributes_dni_image";
      this.ui.customerPhotoBack = "#customer_consent_id_photo_back, #customer_consent_temporal_image_attributes_image1";
      this.ui.customerPhotoWithUser = "#customer_consent_id_photo_with_user, #customer_consent_temporal_image_attributes_image2";
      this.ui.clearSignature = "#sig-clearBtn";
      this.ui.backPhoto = "#back-photo";
      this.ui.previewConsent = "#preview-consent";
      this.ui.submitBtn = "#submitBtn";
      this.ui.signature = "#sig-canvas";
      this.ui.signatureMessage = "#sig-message"
      this.ui.customerSwtich0 = "#customSwitch0"
      this.ui.customerSelfie = "#customer_consent_temporal_image_attributes_image3";
      this.ui.customerPhotoFrontTemp = "#photo_front_temp";
      this.ui.customerSelfieTemp = "#photo_selfie_temp";

      // By Classes
      this.ui.jsFrontPhonto = ".js-front-photo";
      this.ui.jsBackPhoto = ".js-back-photo";
      this.ui.jsCustomerPhoto = ".js-customer-photo";
      this.ui.jsValidateDNI = ".js-validate-dni";
      this.ui.jsSearchCustomer = ".js-search-customer";
    };

    loadComponents() {
      const operation = this;

      operation.configure();
      operation.loadDataCompanyID();
      operation.onlyLetter();
      operation.onlyNumber();
      operation.textUpperCase();
      operation.needFormValidation();
      operation.maskedNumber();
      operation.validateDNI();
      operation.changeLabelOnNationality();
      operation.toggleNationalityCountry();
      operation.toggleBirthCountry();
      operation.loadValidateBirthDate();
      operation.loadCustomerAgeDisplay();
      //operation.loadCustomFileInput();
      operation.loadSearchCustomer();
      operation.loadDocumentScreening();
      //operation.convertImgToBase64(operation.ui.customerPhontoID, operation.ui.customerPhotoFront);
      //operation.convertImgToBase64(operation.ui.backPhoto, operation.ui.customerPhotoBack);
      //operation.loadPreviewConsent();
      operation.loadSendConsent();

      if (gon.global['integration_type']['equality']) {
        this.convertImgToBase64(this.ui.customerPhotoFront, this.ui.customerPhotoFrontTemp);
        this.convertImgToBase64(this.ui.customerSelfie, this.ui.customerSelfieTemp);
        this.addValidatorIdentity();
      }

      $(operation.ui.customerIdNumberConfirmation).rules('add', {
        equalTo: operation.ui.customerIdNumber
      });

      $('#customer_consent_customer_attributes_nit_foreigner_confirmation').rules('add', {
        equalTo: '#customer_consent_customer_attributes_nit_foreigner'
      });

      $(operation.ui.customerCellphone).rules("add", {
        validateCellphone: { loan_id: "true" }
      });

      $(operation.ui.customerEmail).rules("add", {
        validateEmail: { loan_id: "true" }
      });
    };

    validSignature() {
      const operation = this;
      var canvas = $(operation.ui.signature)[0];
      var context = canvas.getContext("2d");
      var imageData = context.getImageData(0, 0, canvas.width, canvas.height).data;

      for (var i = 0; i < imageData.length; i += 4) {
        if (imageData[i + 3] !== 0) {
          $(operation.ui.signatureMessage).text('');
          return true;
        }
      }
      $(operation.ui.signatureMessage).text('Este campo es obligatorio.');
      return false;
    }

    loadSearchCustomer() {
      const operation = this;

      const triggerSearch = function () {
        if (!$(operation.ui.customerIdNumber).valid()) return;
        if (!$(operation.ui.customerIdNumberConfirmation).valid()) return;

        var dni = $(operation.ui.customerIdNumber).val();
        if (!dni) return;
        if (operation._lastSearchedDni === dni) return;
        operation._lastSearchedDni = dni;

        bootbox.dialog({
          centerVertical: true,
          closeButton: false,
          message: i18n.t('bootbox.searching_html')
        });

        operation.resetFillForm();

        $.ajax({
          method: 'GET',
          url: Routes.search_customer_credit_infos_path(),
          data: { id_number: dni, nationality: $(operation.ui.loanCustomerNationality).find('option:selected').val() }
        }).done(function () {
          operation.hideBootBox();
        }).fail(function () {
          operation.hideBootBox();
        }).always(function () {
          operation.hideBootBox();
        });
      };

      $(operation.ui.jsSearchCustomer).on('blur', triggerSearch);
      $(operation.ui.customerIdNumberConfirmation).on('blur', triggerSearch);
    };

    loadDocumentScreening() {
      const operation = this;
      let debounceTimer;

      const toggleDocumentFieldsByCountry = function() {
        const nationality = $(operation.ui.loanCustomerNationality).val();
        const selectedCountry = $(operation.ui.loanCustomerNationalityCountry).val();
        const requiresCountry = nationality && nationality !== 'national' && nationality !== 'naturalized';
        const canTypeDocument = !requiresCountry || !!selectedCountry;

        $(operation.ui.customerIdNumber).prop('disabled', !canTypeDocument);
        $(operation.ui.customerIdNumberConfirmation).prop('disabled', !canTypeDocument);

        if (!canTypeDocument) {
          $(operation.ui.customerIdNumber).val('');
          $(operation.ui.customerIdNumberConfirmation).val('');
        }
      };

      const buildFullName = function() {
        const parts = [
          $('#loan_customer_attributes_first_name').val(),
          $('#loan_customer_attributes_second_name').val(),
          $('#loan_customer_attributes_first_last_name').val(),
          $(operation.ui.customerSecondLastName).val()
        ];

        return parts.filter(Boolean).join(' ').trim();
      };

      const nationalCountryCodes = { gtm: 'GT', pan: 'PA', slv: 'SV', nic: 'NI', hnd: 'HN', pry: 'PY' };

      const getSelectedCountry = function() {
        const nationality = $(operation.ui.loanCustomerNationality).val();
        if (nationality === 'national' || nationality === 'naturalized') {
          const country = gon.global['integration_type']?.['country'] || 'pan';
          return nationalCountryCodes[country] || country.toUpperCase();
        }
        return $(operation.ui.loanCustomerNationalityCountry).val();
      };

      const performValidation = function(skipConfirmation = false) {
        const idNumber = $(operation.ui.customerIdNumber).val();
        const confirmationNumber = $(operation.ui.customerIdNumberConfirmation).val();
        const selectedCountry = getSelectedCountry();
        const firstName = $('#loan_customer_attributes_first_name').val();
        const firstLastName = $('#loan_customer_attributes_first_last_name').val();
        const currentFullName = buildFullName();

        if (!idNumber) return;
        if (!skipConfirmation && !confirmationNumber) return;
        if (!skipConfirmation && idNumber !== confirmationNumber) return;
        if (!selectedCountry) return;
        if (!$(operation.ui.customerIdNumber).valid()) return;
        if (!skipConfirmation && !$(operation.ui.customerIdNumberConfirmation).valid()) return;

        // Only perform OFAC/PEP validation if both first name and last name are present
        if (!firstName || !firstLastName) return;

        // Reset alerts if document or name changed significantly
        if (operation.lastValidatedDocument !== idNumber || operation.lastValidatedName !== currentFullName) {
          operation.ofacAlertShown = false;
          operation.pepAlertShown = false;
          operation.lastValidatedDocument = idNumber;
          operation.lastValidatedName = currentFullName;
        }

        $.ajax({
          method: 'POST',
          url: Routes.validate_document_v1_customer_consents_path(),
          data: {
            document_number: idNumber,
            country: selectedCountry,
            full_name: currentFullName
          },
          dataType: 'json'
        }).done(function(response) {
          console.log('Document screening response:', response);
          operation.handleDocumentScreeningResponse(response);
        }).fail(function(xhr) {
          console.error('Document screening validation failed:', xhr.responseText);
        });
      };

      $(operation.ui.customerIdNumberConfirmation).on('blur', function() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(performValidation, 500);
      });

      // Disparar validación OFAC cuando el usuario escriba nombre o apellido
      $('#loan_customer_attributes_first_name').on('blur', function() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => performValidation(true), 500);
      });

      $('#loan_customer_attributes_second_name').on('blur', function() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => performValidation(true), 500);
      });

      $('#loan_customer_attributes_first_last_name').on('blur', function() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => performValidation(true), 500);
      });

      $(operation.ui.customerSecondLastName).on('blur', function() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => performValidation(true), 500);
      });

      $(operation.ui.loanCustomerNationality).on('change', toggleDocumentFieldsByCountry);
      $(operation.ui.loanCustomerNationalityCountry).on('change', toggleDocumentFieldsByCountry);
      toggleDocumentFieldsByCountry();
    };

    toggleBirthCountry() {
      const operation = this;

      function toggle() {
        var selected = $(operation.ui.loanCustomerNationality).val();
        const isCitizenIdType = selected === 'national' || selected === 'naturalized';

        if (selected && !isCitizenIdType) {
          $('#birth_country_field').removeClass('d-none');
          $(operation.ui.loanCustomerBirthCountry).prop('required', true);
        } else {
          $('#birth_country_field').addClass('d-none');
          $(operation.ui.loanCustomerBirthCountry).prop('required', false);
          $(operation.ui.loanCustomerBirthCountry).val('');
        }

        // Show/hide NIT fields for Cédula E (Panama only)
        if ($('#migration_card_fields').length) {
          if (selected === 'foreigner') {
            $('#migration_card_fields').removeClass('d-none');
            $('#customer_consent_customer_attributes_nit_foreigner').prop('required', true);
            $('#customer_consent_customer_attributes_nit_foreigner').prop('disabled', false);
            $('#customer_consent_customer_attributes_nit_foreigner_confirmation').prop('required', true);
            $('#customer_consent_customer_attributes_nit_foreigner_confirmation').prop('disabled', false);
          } else {
            $('#migration_card_fields').addClass('d-none');
            $('#customer_consent_customer_attributes_nit_foreigner').prop('required', false);
            $('#customer_consent_customer_attributes_nit_foreigner').prop('disabled', true);
            $('#customer_consent_customer_attributes_nit_foreigner').val('');
            $('#customer_consent_customer_attributes_nit_foreigner_confirmation').prop('required', false);
            $('#customer_consent_customer_attributes_nit_foreigner_confirmation').prop('disabled', true);
            $('#customer_consent_customer_attributes_nit_foreigner_confirmation').val('');
          }
        }
      }

      $(operation.ui.loanCustomerNationality).on('change', toggle);
      toggle();
    }

    handleDocumentScreeningResponse(response) {
      const operation = this;

      // Handle OFAC blocking
      if (response.ofac && response.ofac.matched && response.ofac.blocking && !operation.ofacAlertShown) {
        operation.ofacAlertShown = true;
        operation.showOfacBlockingModal(response.ofac);
        return;
      }

      // Handle PEP warning
      if (response.pep && response.pep.matched && !response.pep.blocking && !operation.pepAlertShown) {
        operation.pepAlertShown = true;
        operation.showPepWarningModal(response.pep);
      }
    };

    showOfacBlockingModal(ofacResult) {
      const operation = this;

      // Disable all form inputs in step-0 immediately
      $('#step-0').find('input, select, textarea').prop('disabled', true);

      // Disable submit button and add gray background
      $(operation.ui.submitBtn).prop('disabled', true).css('background-color', '#6c757d').css('opacity', '0.65');

      bootbox.dialog({
        centerVertical: true,
        closeButton: false,
        title: 'Alerta de Cumplimiento OFAC',
        message: ofacResult.message || 'El perfil no puede continuar el proceso.',
        buttons: {
          ok: {
            label: 'Entendido',
            className: 'btn-danger',
            callback: function() {
              // Already disabled above
              return true;
            }
          }
        }
      });
    };

    showPepWarningModal(pepResult) {
      const operation = this;

      bootbox.dialog({
        centerVertical: true,
        closeButton: true,
        title: 'Alerta PEP - Persona Expuesta Políticamente',
        message: pepResult.message || 'Advertencia: el cliente figura como PEP (Persona Expuesta Políticamente).',
        buttons: {
          ok: {
            label: 'Entendido',
            className: 'btn-warning',
            callback: function() {
              // Allow continuing normally
              return true;
            }
          }
        }
      });
    };

    resetFillForm() {
      const operation = this;
      $(operation.ui.customerId).val("");
      $(operation.ui.customerFirstName).val("");
      $(operation.ui.customerSecondName).val("");
      $(operation.ui.customerFirstLastName).val("");
      $(operation.ui.customerSecondLastName).val("");
      $(operation.ui.customerMarriedSurname).val("");
      $(operation.ui.customerBirthDate).val("");
      $(operation.ui.customerGender).val("");
      $(operation.ui.customerCellphone).val("");
      $(operation.ui.customerEmail).val("");
      $(operation.ui.customerPhotoFront).val("");
      $(operation.ui.customerPhotoBack).val("");
      $('#customer_consent_customer_attributes_nit_foreigner').val("");
      $('#customer_consent_customer_attributes_nit_foreigner_confirmation').val("");
      operation.clearLoadFileInput();
      $(operation.ui.clearSignature).click();
      if (typeof operation.resetBiometricVerification === "function") {
        operation.resetBiometricVerification();
      }
    };

    resetBiometricVerification() {
      this.veriffFinished = false;
      this._veriffIdNumber = null;
      $("#customSwitch0").prop("checked", false);
      $("#customer_consent_veriff_session_id, #loan_veriff_session_id").val("");
    };

    fillForm(customer) {
      const operation = this;
      $(operation.ui.personID).val(customer['person_id']);
      $(operation.ui.customerId).val(customer['id']);
      $(operation.ui.customerFirstName).val(customer['first_name']);
      $(operation.ui.customerSecondName).val(customer['second_name']);
      $(operation.ui.customerFirstLastName).val(customer['first_last_name']);
      $(operation.ui.customerSecondLastName).val(customer['second_last_name']);
      $(operation.ui.customerBirthDate).val(customer['birth_date']);
      $(operation.ui.customerGender).val(customer['gender']);
      $(operation.ui.customerCellphone).val(customer['cellphone_number']);
      $(operation.ui.customerEmail).val(customer['email']);
      if (customer['nit']) {
        $('#customer_consent_customer_attributes_nit_foreigner').val(customer['nit']);
        $('#customer_consent_customer_attributes_nit_foreigner_confirmation').val(customer['nit']);
      }
      if (customer['nationality_country']) {
        $(operation.ui.loanCustomerNationalityCountry).val(customer['nationality_country']).trigger('change');
      }
      if (customer['birth_country']) {
        $(operation.ui.loanCustomerBirthCountry).val(customer['birth_country']).trigger('change');
      }
      operation.updateCustomerAgeDisplay();
    };

    loadPreviewConsent() {
      const operation = this;
      $(operation.ui.previewConsent).on('click', function () {
        if (!$(operation.ui.jsFormValidation).valid()) {
          return false;
        };

        if (!operation.validSignature()) {
          return false;
        };

        var formData = new FormData($(".js-need-validation")[0]);
        bootbox.dialog({
          centerVertical: true,
          closeButton: false,
          message: i18n.t('bootbox.processing_html')
        });

        $.ajax({
          method: 'POST',
          url: Routes.preview_customer_consents_path(),
          processData: false,
          contentType: false,
          data: formData
        }).done(function (response) {
          operation.hideBootBox();
        }).fail(function () {
          operation.hideBootBox();
        });
      });
    };

    loadSendConsent() {
      const operation = this;
      $("form#FormConsent").bind("ajax:beforeSend", function (event, data, status, xhr) {
        //if (!operation.validSignature()) {
        //  event.preventDefault();
        //  return;
        //};

        bootbox.dialog({
          centerVertical: true,
          closeButton: false,
          message: i18n.t('bootbox.processing_html')
        });
      }).bind("ajax:complete", function (event, data, status, xhr) {
        $('.bootbox.modal').modal('hide');
      }).bind("ajax:success", function (event, data, status, xhr) {
        $('.bootbox.modal').modal('hide');
      });
    };
  };

  window.CustomerConsent = CustomerConsent;
})();


